export enum WREX_TABLE {
    /**
     * @value Delete table?
     * @description Title of the table deletion confirmation dialog
     */
    DELETE_TABLE_TITLE_CONFIRMATION = 'WREX_TABLE.DELETE_TABLE_TITLE_CONFIRMATION',
    /**
     * @value Table
     * @description The label of the button to insert a table in the rich editor toolbar.
     */
    TABLE_BUTTON = 'WREX_TABLE.TABLE_BUTTON',
    /**
     * @value Add a column after
     */
    TABLE_TOOLBAR_ADD_COLUMN_AFTER = 'WREX_TABLE.TABLE_TOOLBAR_ADD_COLUMN_AFTER',
    /**
     * @value Add a column before
     */
    TABLE_TOOLBAR_ADD_COLUMN_BEFORE = 'WREX_TABLE.TABLE_TOOLBAR_ADD_COLUMN_BEFORE',
    /**
     * @value Add a row after
     */
    TABLE_TOOLBAR_ADD_ROW_AFTER = 'WREX_TABLE.TABLE_TOOLBAR_ADD_ROW_AFTER',
    /**
     * @value Add a row before
     */
    TABLE_TOOLBAR_ADD_ROW_BEFORE = 'WREX_TABLE.TABLE_TOOLBAR_ADD_ROW_BEFORE',
    /**
     * @value Delete column
     */
    TABLE_TOOLBAR_DELETE_COLUMN = 'WREX_TABLE.TABLE_TOOLBAR_DELETE_COLUMN',
    /**
     * @value {"one":"Delete %NB% column","other":"Delete %NB% columns"}
     */
    TABLE_TOOLBAR_DELETE_COLUMNS = 'WREX_TABLE.TABLE_TOOLBAR_DELETE_COLUMNS',
    /**
     * @value Delete row
     */
    TABLE_TOOLBAR_DELETE_ROW = 'WREX_TABLE.TABLE_TOOLBAR_DELETE_ROW',
    /**
     * @value {"one":"Delete %NB% row","other":"Delete %NB% rows"}
     */
    TABLE_TOOLBAR_DELETE_ROWS = 'WREX_TABLE.TABLE_TOOLBAR_DELETE_ROWS',
    /**
     * @value Delete table
     */
    TABLE_TOOLBAR_DELETE_TABLE = 'WREX_TABLE.TABLE_TOOLBAR_DELETE_TABLE',
    /**
     * @value Table is intended for organizing tabular data, not for layout purposes. This practice undermines accessibility, especially for screen readers.
     * @description Message displayed in a wrex table when hovering an information button. This message warn the user of the usage of the table
     */
    TABLE_TOOLBAR_INFORMATION_MESSAGE = 'WREX_TABLE.TABLE_TOOLBAR_INFORMATION_MESSAGE',
    /**
     * @value Header row
     * @description Label used to toggle the header row of a wrex table
     */
    TABLE_TOOLBAR_TOGGLE_HEADER_ROW = 'WREX_TABLE.TABLE_TOOLBAR_TOGGLE_HEADER_ROW',
}
